import React, { useState, useEffect } from 'react';
import { useSpring, animated } from '@react-spring/web';

// import InputAutocomplete from '../input-autocomplete';
import { DatePicker, InputNumber } from 'antd';
import moment from 'moment';
import Autocomplete from "react-google-autocomplete";


import apiService from '../../services/api-service';

import TripModal from '../trip-modal';

const autocompleteStyles = {
    width: '100%',
    height: 60,
    padding: 15,
    fontSize: 11,
    fontFamily: 'Montserrat',
    fontWeight: 500,
    color: 'black',
    lineHeight: 60,
    letterSpacing: 'wide',
    outline: 'none',
    borderRadius: 0,
    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    border: `5px solid #EDEDED`,
};

const TripForm = ({ onSubmit }) => {
    
    const [showModal, setShowModal] = useState(true);
    const originInputRef = React.useRef(null);
    const destinationInputRef = React.useRef(null);

    const [origin, setOrigin] = React.useState(null);
    const [destination, setDestination] = React.useState(null);

    const [tripForm, setForm] = React.useState({
        date: null,
        nbPassengers: 1
    });

    const handleCalculateTrip = async() => {
        onSubmit({
            origin: origin,
            destination: destination,
            date: tripForm.date,
            nbPassengers: tripForm.nbPassengers
        });
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: 450,
            height: 'auto'
        }}>
            <Autocomplete
                ref={originInputRef}
                apiKey='AIzaSyA6HyP2mA-TXau94xMtljsP3HjUFDdc5CQ'
                style={{
                    ...autocompleteStyles,
                    borderColor: `${!!origin ? '#ABEFFF' : '#EDEDED'}`,
                }}
                onPlaceSelected={(place) => {
                    console.log('Origin selected', place);
                    setOrigin(place);
                }}
                types={['(regions)']}
                componentRestrictions={{ country: "fr" }}
            />
            <Autocomplete
                ref={destinationInputRef}
                apiKey='AIzaSyA6HyP2mA-TXau94xMtljsP3HjUFDdc5CQ'
                style={{
                    ...autocompleteStyles,
                    borderColor: `${!!destination ? '#ABEFFF' : '#EDEDED'}`,
                    marginTop: 10
                }}
                onPlaceSelected={(place) => {
                    console.log('Destination selected', place);
                    setDestination(place);
                }}
                types={['(regions)']}
                componentRestrictions={{ country: "fr" }}
            />
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 10
            }}>
                <InputNumber
                    placeholder='Nb passagers'
                    style={{
                        ...autocompleteStyles,
                        borderColor: `${!!tripForm.nbPassengers ? '#ABEFFF' : '#EDEDED'}`,
                        height: 60,
                    }}
                    value={tripForm.nbPassengers}
                    onChange={(value) => {
                        setForm({
                            ...tripForm,
                            nbPassengers: value
                        });
                    }}
                />
                <DatePicker
                    className='w-full'
                    placeholder='Date'
                    format='DD/MM/YYYY HH:mm'
                    showTime={{ format: 'HH:mm' }}
                    style={{
                        ...autocompleteStyles,
                        borderColor: `${!!tripForm.date ? '#ABEFFF' : '#EDEDED'}`,
                        marginLeft: 10,
                        marginTop: 0,
                        fontSize: 11
                    }}
                    onChange={(date, dateString) => {
                        setForm({
                            ...tripForm,
                            date: date
                        });
                    }}
                />
            </div>
    
            <div className='flex w-full mt-[12px]'>
                <button 
                    style={{
                        ...autocompleteStyles,
                        backgroundColor: `${( !!origin && !!destination && !!tripForm.date ) ? '#06CAFF' : '#EDEDED'}`,
                        fontWeight: 'bold',
                        color: '#ffffff',
                        textTransform: 'uppercase',
                        letterSpacing: 'wider',
                        marginTop: 10
                    }}
                    onClick={() => {
                        handleCalculateTrip();
                        setShowModal(true);
                    }}
                >
                    Calculer
                </button>
            </div>
            {/* <TripModal isDisplay={showModal} onClose={() => setShowModal(false)} trip={trip} /> */}
        </div>
    );
}

export default TripForm;